import { render, staticRenderFns } from "./DetailNoteChat.vue?vue&type=template&id=444fa912&scoped=true&lang=html&"
import script from "./DetailNoteChat.vue?vue&type=script&lang=js&"
export * from "./DetailNoteChat.vue?vue&type=script&lang=js&"
import style0 from "./DetailNoteChat.vue?vue&type=style&index=0&id=444fa912&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444fa912",
  null
  
)

export default component.exports